// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__PyXlK","validationTips":"StatementDescriptor_validationTips__eHNwR"};